import PropTypes from 'prop-types';
import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Checkbox, Tooltip } from 'antd';

export default class ServerCookieCheckbox extends React.Component {
    static propTypes = {
        toggleWriteFirstPartyCookiesFromServer: PropTypes.func.isRequired,
        writeFirstPartyCookiesFromServer: PropTypes.bool.isRequired,
        tooltipPlacement: PropTypes.oneOf(['right', 'bottom']).isRequired,
    }

    render() {
        return (
            <div className='mms-domain'>
                <Checkbox
                    className='auto-scan'
                    checked={this.props.writeFirstPartyCookiesFromServer}
                    onChange={this.props.toggleWriteFirstPartyCookiesFromServer}
                    disabled={this.props.readOnly}
                >
                    Write 1st Party Cookies from the server
                    <Tooltip title="Used to set first-party cookies on the site's top-level domain. Requires a domain to be setup as the same top-level domain of your site; that CNAME's to mms.sp-prod.net." placement="right">
                        <InfoCircleOutlined />
                    </Tooltip>
                </Checkbox>
                {this.props.showWarning && <p className='invalid-url'>Requires a domain to be setup with the same top-level domain of your site; that CNAME's to mms.sp-prod.net.</p>}
            </div>
        );
    }
}
